import { fetchStopListEntries } from '@/services/stopListService'

const stopListInFlight = new Map()
const stopListLastFetch = new Map()
const STOPLIST_DEDUP_TTL_MS = 2000

export default {
    fetchStopListsByRestaurantId({ commit }, divisionId) {
        if (!divisionId) {
            commit('SET_STOP_LIST', [])
            return Promise.resolve([])
        }

        const inFlight = stopListInFlight.get(divisionId)
        if (inFlight) return inFlight

        const last = stopListLastFetch.get(divisionId)
        if (last && Date.now() - last < STOPLIST_DEDUP_TTL_MS) {
            return Promise.resolve([])
        }

        const request = (async () => {
            try {
                const response = await fetchStopListEntries(divisionId, {
                    active_only: true,
                    limit: 9999, // TODO для получения всех записей
                    offset: null,
                })

                commit('SET_STOP_LIST', response?.data?.items || [])
                stopListLastFetch.set(divisionId, Date.now())
                return []
            } catch (error) {
                commit('SET_STOP_LIST', [])
                return []
            } finally {
                stopListInFlight.delete(divisionId)
            }
        })()

        stopListInFlight.set(divisionId, request)
        return request
    },
}
